// The quiet "Purchase Mao Coins →" link at the foot of every pop-up where you spend coin. One click closes the pop-up and
// opens the Shop. Deliberately low-key (a text link, not a button): see .hud__buy-coins in hud.css.
import { setActivePage } from './siteRouter.js'

export const BUY_COINS_HTML = '<div class="hud__buy-coins-row"><button class="hud__buy-coins" data-buy-coins type="button">Purchase Mao Coins →</button></div>'

// Wire every [data-buy-coins] inside `container`. `close` dismisses the pop-up it lives in.
export function wireBuyCoins(container, close) {
  container.querySelectorAll('[data-buy-coins]').forEach((b) => {
    if (b.__wired) return
    b.__wired = true
    b.addEventListener('click', () => { close?.(); setActivePage('shop') })
  })
}

// For the rail panels (Build / Career / Feed / Citizens): add the link as the last row of the panel.
export function appendBuyCoinsLink(root) {
  root.insertAdjacentHTML('beforeend', BUY_COINS_HTML)
  wireBuyCoins(root, () => root.classList.remove('open'))
}
